import { useInkind } from '@gik/api/inkinds/inkind';
import { useInkindCan } from '@gik/core/store/permissions';
import bemBlock from '@gik/core/utils/bemBlock';
import { nativeShareSupported } from '@gik/core/utils/browser';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import commonTranslationKeys from '@gik/i18n/en/common';
import { inkindPageTourSelectors } from '@gik/inkind-page/components/InkindPageTour/InkindPageTour';
import { Button } from '@gik/ui/Button';
import type { IButtonProps } from '@gik/ui/Button/ButtonProps';
import ShareAlt from '@gik/ui/SvgIcon/GikIcons/ShareAlt';
import { SvgIcon } from '@gik/ui/SvgIcon/SvgIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { openShareInkindModal } from '../ShareInkindModal/openShareInkindModal';

export type ShareInkindButtonProps = IButtonProps & {
  inkindRouteId: string;
};

function ShareInkindButtonComp({ inkindRouteId, ...otherProps }: ShareInkindButtonProps): JSX.Element {
  const { t } = useTranslation();
  const { data: inkindPage } = useInkind(inkindRouteId);
  const bem = bemBlock('share-inkind-button');

  const canEdit = useInkindCan('manage', inkindRouteId, inkindPage?.groupId);

  return (
    <Button
      id={inkindPageTourSelectors.shareButton}
      className={bem()}
      block
      size="lg"
      append={<SvgIcon Icon={ShareAlt} size="xl" />}
      loading={!inkindPage}
      onClick={() =>
        openShareInkindModal(
          {
            pageTitle: inkindPage.title,
            pageShortUrl: inkindPage.shortUrl,
            inkindRouteId: inkindPage.routeId,
            emailInvitationsButton: canEdit,
            moreOptionsButton: nativeShareSupported(),
          },
          'inkindPage',
          inkindPage.url,
          canEdit
        )
      }
      {...otherProps}
    >
      {t(commonTranslationKeys.common.share).toString()}
    </Button>
  );
}

export const ShareInkindButton = withComponentErrorBoundary(ShareInkindButtonComp);
